import { useEffect } from 'react';

interface IUseKeypress {
  key: string;
  skip?: boolean;
  handler: () => void;
}

const useKeypress = ({ key, skip, handler }: IUseKeypress): void => {
  useEffect(() => {
    if (skip) return;
    const onKeyup = (event: KeyboardEvent): void => {
      if (event.key === key) {
        handler();
      }
    };
    document.addEventListener('keyup', onKeyup);
    return (): void => document.removeEventListener('keyup', onKeyup);
  }, [key, skip, handler]);
};

export default useKeypress;
